export const ADDRESS_ACTION_TYPES = {
  ADD_NEW_ADDRESS: 'ADD_NEW_ADDRESS',
  CHANGE_ADDRESS: 'CHANGE_ADDRESS',
  DELETE_ADDRESS: 'DELETE_ADDRESS',
}
export const VOUCHER_ACTION_TYPES = {
  ADD_VOUCHER: 'ADD_VOUCHER',
  EDIT_VOUCHER: 'EDIT_VOUCHER',
}
